import { Grid, TextField, Typography } from '@mui/material';
import styles from '../reportSection.module.scss'
import { CommonButton, CustomCalendarTodayOutlinedIcon, CustomDatePicker, CustomInputLabel, CustomRequiredInputLabel, CustomTextFeildforFamily, StyledDateContainer } from '../../common/StyledComponents/StyledFields';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useState } from 'react';
import { ValidationError, object, string } from 'yup';
import dayjs from 'dayjs';

const PoojaBooking = () => {
    interface ErrorMessageTypes {
        signInName: string;
        donationDateFrom: string;
        donationDateTo: string;
    }
    const formFields = {
        signInName: "",
        donationDateFrom: "",
        donationDateTo: ""
    }

    const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({ ...formFields });
    const [formData, setFormData] = useState(formFields);

    const validationSchema = object().shape({
        signInName: string().required('Sign-In Name is required'),
        donationDateFrom: string()
            .required('Donation Date From is required'),
        donationDateTo: string().required('Donation Date To is required'),
    });
    const handlSubmit = async () => {
        const errors: ErrorMessageTypes = {
          ...formFields
        }
        try {
            // Validate the form data against the validation schema
            await validationSchema.validate(formData, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessage(errors);
            // Call your API or perform other actions here
            // saveApiCall();

        } catch (error) {
            // Handle validation errors

            if (error instanceof ValidationError) {
                error.inner.forEach((e) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypes] = e.message;
                    }
                });
            }
            setErrorMessage(errors);
        }
    }

    const DobDatePickerTo = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
            <StyledDateContainer className={styles.styledConatiner}
            >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formData.donationDateTo ? dayjs(formData.donationDateTo, 'MM-DD-YYYY') : ''
                                }
                                onChange={(value) => {
                                    setErrorMessage({ ...errorMessage, donationDateTo: '' });
                                }}
                                disableFuture
                                className={errorMessage.donationDateTo ? styles.errorTextField : styles.dateFeildforfamily}
                            />

                        </DemoContainer>
                    </LocalizationProvider>
                    {errorMessage.donationDateTo ? (
                        <Typography sx={{ color: 'red', fontSize: '12px' }}>
                            {errorMessage.donationDateTo}
                        </Typography>
                    ) : (
                        ''
                    )}
                </StyledDateContainer>
            </div>
        );
    };
    const DobDatePickerDonation = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
            <StyledDateContainer className={styles.styledConatiner}
            >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formData.donationDateFrom ? dayjs(formData.donationDateFrom, 'MM-DD-YYYY') : ''
                                }
                                onChange={(value) => {
                                    setErrorMessage({ ...errorMessage, donationDateFrom: '' });
                                }}
                                disableFuture
                                className={errorMessage.donationDateFrom ? styles.errorTextField : styles.dateFeildforfamily}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                    {errorMessage.donationDateFrom ? (
                        <Typography sx={{ color: 'red', fontSize: '12px' }}>
                            {errorMessage.donationDateFrom}
                        </Typography>
                    ) : (
                        ''
                    )}
                </StyledDateContainer>
            </div>
        );
    };
    return (
        <div>
            <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                <Grid item xs={12} sm={4}>
                    <CustomInputLabel>Sign-In Name</CustomInputLabel>
                    <CustomTextFeildforFamily
                        style={{ minWidth: '100%', borderRadius: "8px" }}
                        fullWidth
                        required
                        value={formData.signInName}
                        onChange={(e: any) => {
                            setErrorMessage({ ...errorMessage, signInName: '' });
                        }}
                        className={errorMessage.signInName ? styles.errorTextField : styles.dateFeild}
                    />

                    {errorMessage.signInName ? (
                        <Typography sx={{ color: 'red', fontSize: '12px' }}>
                            {errorMessage.signInName}
                        </Typography>
                    ) : (
                        ''
                    )}
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={4}>
                    {CustomRequiredInputLabel("Search by Donation Date From", true)}
                    {DobDatePickerDonation()}
                </Grid>
                <Grid item xs={12} sm={4}>
                    {CustomRequiredInputLabel("Search by Donation Date To", true)}
                    {DobDatePickerTo()}
                </Grid>
            </Grid>
            <Grid sx={{ mt: 3 }}>
                <CommonButton onClick={handlSubmit}>Submit</CommonButton>
            </Grid>
        </div>
    )
}
export default PoojaBooking;
